import {
  ExternalCalendar,
  ExternalConnectionCalendarsCache,
} from '@griply/types';

import { DocumentSnapshot } from '../types/firestore';
import { firebaseTimestampToDate } from './firebase-timestamp-to-date';

const coerceCalendar = (value: unknown): ExternalCalendar | null => {
  if (!value || typeof value !== 'object') {
    return null;
  }
  const entry = value as Record<string, unknown>;
  if (typeof entry.id !== 'string' || !entry.id) {
    return null;
  }
  return {
    id: entry.id,
    name: typeof entry.name === 'string' ? entry.name : '',
    description: typeof entry.description === 'string' ? entry.description : '',
    color: typeof entry.color === 'string' ? entry.color : '',
    timeZone: typeof entry.timeZone === 'string' ? entry.timeZone : null,
    // absence carries meaning on ExternalCalendar — only pass real booleans through
    ...(typeof entry.canWrite === 'boolean'
      ? { canWrite: entry.canWrite }
      : {}),
    ...(typeof entry.supportsVideoCall === 'boolean'
      ? { supportsVideoCall: entry.supportsVideoCall }
      : {}),
  };
};

// shared by the converter AND the getCalendars callable — both legs feed the same query cache
export const coerceCalendars = (value: unknown): ExternalCalendar[] =>
  Array.isArray(value)
    ? value
        .map(coerceCalendar)
        .filter((calendar): calendar is ExternalCalendar => calendar !== null)
    : [];

export const externalConnectionCalendarsConverter = {
  fromFirestore: (
    snapshot: DocumentSnapshot,
  ): ExternalConnectionCalendarsCache => {
    const data = (snapshot.data() ?? {}) as Record<string, unknown>;
    return {
      id: snapshot.id,
      calendars: coerceCalendars(data.calendars),
      updatedAt: data.updatedAt
        ? firebaseTimestampToDate(data.updatedAt as Date)
        : null,
    };
  },
  toFirestore: (cache: ExternalConnectionCalendarsCache) => cache,
};
